import { Http } from '../../shared';
import { settings } from '../../settings';

export class OrderService {
    constructor() {
        this.http = new Http();
        this.b2c_api_url = settings.b2c_api;
        this.admin_api_url = settings.admin_api;
    }

    async find(id) {
        var options = {
            headers: {
                'Content-Type': 'application/json'
            }
        }

        var response = await this.http.get(`${this.b2c_api_url}/orders/${id}`, options);
        return response.data;
    }
    async search(query) {
        var options = {
            headers: {
                'Content-Type': 'application/json'
            },
            params: query
        }
        var response = await this.http.get(`${this.b2c_api_url}/orders`, options);
        var result = {
            data: response.data,
            page_size: response.headers['x-pagination-page-size'],
            page_number: response.headers['x-pagination-page-number'],
            total_size: response.headers['x-pagination-total-size'],
        };
        return result;
    }
    async addNote(locale, order_id, note) {
        var response = await this.http.post(`${this.admin_api_url}/orders/${order_id}/notes`, {
            note: note,
            locale: locale
        });
        return response.data;
    }
    async updateContact(order_id, contact) {
        var response = await this.http.put(`${this.admin_api_url}/orders/${order_id}/contact`, contact);
        return response.data;
    }
    async updateVehicles(order_id, v) {
        var response = await this.http.put(`${this.admin_api_url}/orders/${order_id}/vehicles`, v);
        return response.data;
    }
    async cancel(order_id) {
        var options = {
            headers: {
                'Content-Type': 'application/json'
            }
        }
        var response = await this.http.post(`${this.admin_api_url}/orders/${order_id}/cancel`, {}, options);
        return response.data;
    }
    async cancelLeg(id, leg_id, data) {
        var options = {
            headers: {
                'Content-Type': 'application/json'
            }
        }

        var response = await this.http.post(`${this.admin_api_url}/orders/${id}/legs/${leg_id}/cancel`, data, options);
        return response.data;
    }
    async createCheckout(id, data) {
        var options = {
            headers: {
                'Content-Type': 'application/json'
            }
        }

        var response = await this.http.post(`${this.b2c_api_url}/orders/${id}/checkouts`, data, options);
        return response.data;
    }
    async openSupport(order_id) {
        var options = {
            headers: {
                'Content-Type': 'application/json'
            }
        }

        var response = await this.http.post(`${this.admin_api_url}/orders/${order_id}/open-support`, {}, options);
        return response.data;
    }
    async closeSupport(order_id) {
        var options = {
            headers: {
                'Content-Type': 'application/json'
            }
        }

        var response = await this.http.post(`${this.admin_api_url}/orders/${order_id}/close-support`, {}, options);
        return response.data;
    }
    async refund(order_id, amount) {
        var response = await this.http.post(`${this.admin_api_url}/orders/${order_id}/refund`,
            {
                amount: amount
            });
        return response.data;
    }
    async getPdf(id, template) {
        var options = {
            responseType: 'blob'
        }

        var response = await this.http.get(`${this.b2c_api_url}/orders/${id}/pdf?template=${template}`, options);
        return response.data;
    }
    async getHtml(id, template) {
        var response = await this.http.get(`${this.b2c_api_url}/orders/${id}/html?template=${template}`);
        return response.data;
    }
    async getCancellationFee(id) {
        var response = await this.http.get(`${this.admin_api_url}/orders/${id}/cancellation-fee`);
        return response.data;
    }
    async getLegCancellationFee(id, leg_id) {
        var response = await this.http.get(`${this.admin_api_url}/orders/${id}/legs/${leg_id}/cancellation-fee`);
        return response.data;
    }
    async addFee(order_id, data) {
        var response = await this.http.post(`${this.admin_api_url}/orders/${order_id}/fees`,data);
        return response.data;
    }
    async addLegFee(order_id, leg_id, data) {
        var response = await this.http.post(`${this.admin_api_url}/orders/${order_id}/legs/${leg_id}/fees`,data);
        return response.data;
    }
    async getTimeLines(id) {
        var response = await this.http.get(`${this.b2c_api_url}/orders/${id}/timelines`);
        return response.data;
    }
}
